<highcharts-chart
class="grafic"
[Highcharts]="Highcharts"
[options]="chartOptions"
></highcharts-chart>

<!--Used to hide 'highchart'-->
<div class="tag-container">
    <div class="tag disguise"></div>
</div>